"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Grid = _interopRequireDefault(require("./Grid"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const genYears = () => {
  const nowYear = new Date().getFullYear();
  const years = [];
  const startYear = nowYear - 4;

  for (let i = 0; i < 9; i++) {
    years.push(startYear + i);
  }

  return years;
};

const years = genYears();

const yearIdx = year => {
  return years.findIndex(item => item === year);
};

const handleYearSelect = onSelect => idx => {
  return onSelect(years[idx]);
};

const YearSelector = ({
  className,
  year,
  onSelect
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: className
}, /*#__PURE__*/_react.default.createElement(_Grid.default, {
  items: years,
  cols: 3,
  select: yearIdx(year),
  onSelect: handleYearSelect(onSelect)
}));

var _default = (0, _styledComponents.default)(YearSelector).withConfig({
  displayName: "YearSelector",
  componentId: "pvvh62-0"
})(["display:flex;height:100%;"]);

exports.default = _default;